import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AnalyticsService } from '../../services/analytics.service';
// import { GSDIntlTelInputCountry } from './gsd-intl-tel-input-country';

@Component({
  selector: 'gsd-intl-tel-input-modal',
  templateUrl: 'gsd-intl-tel-input-modal.html',
  styleUrls: ['./gsd-intl-tel-input.component.scss'],
})
export class GSDIntlTelInputModal {
  // Data passed in by componentProps
  @Input() allCountries: string;
  @Input() preferredCountries: string;
  @Input() selectedCountry: string;

  constructor(
    private analytics: AnalyticsService,
    public modalCtrl: ModalController,
  ) {}

  ionViewDidEnter() {
    this.analytics.trackScreen('GSDIntlTelInputModal');
  }

  // ngOnInit() {
  //   console.log('ngOnInit()');
  //   //console.log( 'selectedCountry    ' + this.selectedCountry );
  // }

  onCountrySelect(country) {
    this.analytics.track('qt_country_code_select', { ui: true, country });
    this.modalCtrl.dismiss({
      country: country,
    });
  }

  dismiss() {
    this.analytics.track('qt_country_code_back', { ui: true });
    this.modalCtrl.dismiss();
  }
}
